const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const MONTHS_SHORT = MONTHS.map(m => m.slice(0, 3));
export const DAY_OF_WEEK_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const isoDate = (year: number, month: number, day: number) =>
  `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

export const parseIsoDate = (key: string) => {
  const [year, month, day] = key.split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const daysBetweenInclusive = (start: string, end: string) =>
  Math.round((parseIsoDate(end).getTime() - parseIsoDate(start).getTime()) / 86400000) + 1;

export const formatMonthLabel = (year: number, month: number) => `${MONTHS[month]} ${year}`;

export const formatShortDate = (key: string) => {
  const dt = parseIsoDate(key);
  return `${MONTHS_SHORT[dt.getMonth()]} ${dt.getDate()}`;
};

export const formatDateRange = (start: string, end: string) =>
  start === end ? formatShortDate(start) : `${formatShortDate(start)} – ${formatShortDate(end)}`;

// The API works in ISO datetimes ("...T00:00:00.000Z"); our internal HolidayBlock only
// tracks the date part ("YYYY-MM-DD"), so convert at the boundary in both directions.
export const toApiDateTime = (dateKey: string) => `${dateKey}T00:00:00.000Z`;
export const fromApiDateTime = (value: string) => value.slice(0, 10);
